import React from 'react';
import { connect } from 'react-redux';
import { updateWebsiteButton } from '../../../../actions/waitingArea';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { updateShowWebsiteButtonWaitingArea } from '../../../../actions/modal';
//TODO: add save changes, Copy button
export class RightPanelTopwebsiteButton extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
  }
  closeModal = () => {
    this.props.dispatch(updateShowWebsiteButtonWaitingArea(false));
  };
  createWaitingAreaWebsiteButton = () => {
    let areThereErrors = forceValidation(undefined, undefined, 'createWebsiteButtonDetails');
    if (!areThereErrors) {
      let cb = () => {};
      this.props.dispatch(updateWebsiteButton(this.props.waitingAreaWebsiteButton, cb));
    }
  };

  render() {
    let saveClasses =
      'ui disable labeled icon button icon color-button color-button-hover color-white  max-width left-text mrlnull mrbnull';

    return (
      <div className="ui actions mrbl mrts max-width ">
        <button
          type="button"
          tabIndex="6"
          onClick={this.createWaitingAreaWebsiteButton}
          data-group="createWebsiteButtonDetails"
          className={
            this.props.waitingAreaWebsiteButton && this.props.waitingAreaWebsiteButton.fetchingWebSiteButtonDetails
              ? saveClasses + ' loading'
              : saveClasses
          }
        >
          {APP.LANGUAGE.ApplyChanges}
          <i className="checkmark  icon" />
        </button>
        <button
          type="button"
          tabIndex="7"
          onClick={this.closeModal}
          className="ui   labeled icon button color-bad-things color-bad-things-hover color-white    mrtm max-width left-text mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Close}
        </button>
      </div>
    );
  }
}

let reduxGetterSetter = connect()(RightPanelTopwebsiteButton); //CONNECT IS A REACT HELPER FUNCTION

export default reduxGetterSetter;
